// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const collapsedDrawerWidth = 70;
export const appDrawerWidth = 320;
